import getRoleProperty from '../getRoleProperty';
import _ from 'lodash';

class ContactRoleWCLaborClientCtrl {
    constructor() {
        this.$onInit = () => {
            const {fieldGetter} = getRoleProperty(this.roleType, this.roleModel, 'laborClient', 'wCLaborContact');
            const details = fieldGetter(undefined, 'laborContactDetails.children') || [];

            this.laborClientDetails = details.map(detail => {
                return {
                    inclusion: _.get(detail, 'inclusion.value.name'),
                    state: _.get(detail, 'state.value.name'),
                    contractEffectiveDate: _.get(detail, 'contractEffectiveDate.value'),
                    contractExpirationDate: _.get(detail, 'contractExpirationDate.value'),
                    descriptionOfDuties: _.get(detail, 'descriptionOfDuties.value'),
                    workLocation: _.get(detail, 'workLocation'),
                    numberOfEmployees: _.get(detail, 'numberOfEmployees')
                };
            });
        };
    }
}

export default ContactRoleWCLaborClientCtrl;

